import styled from 'styled-components';
import { theme } from '../theme';

export const Section = styled.section<{ bg?: string; color?: string }>`
  padding: 4rem 2.5rem;
  background: ${({ bg }) => bg || theme.colors.blackBg};
  color: ${({ color }) => color || theme.colors.white};
  font-family: ${theme.font.main};
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 700px) {
    padding: 2.5rem 1rem;
  }
`;

export const Title = styled.h2`
  font-size: 2.2rem;
  color: #FFFFFF;
  margin-bottom: 1.2rem;
  font-family: 'Segoe UI Semibold', 'Inter', Arial, sans-serif;
  letter-spacing: -1px;
`;

export const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #B7B7B7;
  margin-bottom: 2.5rem;
  max-width: 600px;
`;

export const Button = styled.button`
  background: ${theme.colors.green};
  color: ${theme.colors.black};
  border: none;
  padding: 0.85rem 2.25rem;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(49,236,86,0.08);
  transition: background 0.2s, box-shadow 0.2s;
  &:hover {
    background: ${theme.colors.darkGreen};
    color: ${theme.colors.white};
    box-shadow: 0 4px 16px rgba(49,236,86,0.16);
  }
`;

export const Card = styled.div<{ bg?: string; color?: string }>`
  background: ${({ bg }) => bg || theme.colors.gray};
  color: ${({ color }) => color || theme.colors.white};
  border: 1px solid ${theme.colors.border};
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(24,26,27,0.16);
  padding: 2rem;
  margin: 1rem;
  flex: 1 1 260px;
  min-width: 260px;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const CardTitle = styled.h4`
  font-size: 1.15rem;
  color: ${theme.colors.green};
  margin-bottom: 0.5rem;
  font-family: ${theme.font.heading};
`;

export const CardText = styled.p`
  color: #E0E0E0;
  font-size: 1rem;
`;
